module.exports = __webpack_public_path__ + "static/img/brees-2015-slide-2.db60a15.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/brees-2015-slide-2.jpg
// module id = foxK
// module chunks = 1